import { render, staticRenderFns } from "./RasmusShowUser.vue?vue&type=template&id=65f652a6&"
import script from "./RasmusShowUser.vue?vue&type=script&lang=ts&"
export * from "./RasmusShowUser.vue?vue&type=script&lang=ts&"
import style0 from "./RasmusShowUser.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports